export * from "./compare.js";
//# sourceMappingURL=index.js.map